import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { useCurrentHelpTopic } from '../../../store/useHelpTopics';
import { HelpCircle, AlertCircle, BookOpen, MessageSquarePlus } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const GET_HELP_TOPIC = gql`
  query GetHelpTopic($name: String!) {
    getHelpTopic(name: $name) {
      id
      name
      content
    }
  }
`;
export const Help = () => {
  const currentHelpTopic = useCurrentHelpTopic();
  const topicName = currentHelpTopic();
  const displayTopicName = topicName === 'Default' ? 'Diversion Database Help' : topicName;
  
  const { loading, error, data } = useQuery(GET_HELP_TOPIC, {
    variables: { name: topicName },
    skip: !topicName,
  });

  if (loading) return (
    <div className="min-h-[200px] flex items-center justify-center bg-gray-50 rounded-lg">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent align-[-0.125em]"></div>
        <div className="mt-4 text-sm font-medium text-gray-600">Loading help content...</div>
      </div>
    </div>
  );

  if (error) return (
    <div className="rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">Error Loading Help</h3>
          <div className="mt-2 text-sm text-red-700">{error.message}</div>
        </div>
      </div>
    </div>
  );

  if (!data || !data.getHelpTopic) return (
    <div className="rounded-md bg-yellow-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <HelpCircle className="h-5 w-5 text-yellow-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">No Help Content</h3>
          <div className="mt-2 text-sm text-yellow-700">
            No help topic found for this section
          </div>
        </div>
      </div>
    </div>
  );

  const openFooterSupport = () => {
    window.dispatchEvent(new Event('footer-support:open'));
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Help Content Card */}
        <div className="bg-white shadow-sm rounded-lg">
        <div className="border-b border-gray-200 px-6 py-4">
          <div className="flex items-start justify-between gap-4">
            <div className="flex flex-col space-y-2">
              <div className="flex items-center space-x-2">
              <BookOpen className="h-5 w-5 text-gray-400" />
              <h1 className="text-xl font-semibold text-gray-900">
                Diversion Database Help
              </h1>
              </div>
              <div className="text-sm text-gray-500">
                Topic: {displayTopicName || 'Support'}
              </div>
            </div>
            <Button variant="outline" onClick={openFooterSupport} className="gap-2 shrink-0">
              <MessageSquarePlus className="h-4 w-4" />
              Contact Support
            </Button>
          </div>
        </div>
          
          <div className="px-6 py-4">
            <div className="prose max-w-none">
              <div 
                className="text-gray-600 space-y-4"
                dangerouslySetInnerHTML={{ 
                  __html: data.getHelpTopic.content 
                }} 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 
